

function QuadProd(props) {
  return (

      <div class="col-sm-12 col-12 box-1"  data-aos="fade-up" data-aos-delay="300">
        <div class="row box">
            <div class="col-sm-1 col-12">
                <i class={props.icon} aria-hidden="true"></i>
            </div>
            <div class="col-sm-11 col-12">
                <h3>{props.titulo}</h3>
                <h4><a href={props.link} target={"_blank"} rel="noopener noreferrer">{props.meio}</a></h4>
                <h6>Publicado em {props.data}</h6>
                <h6>{props.status}</h6>
                <p>{props.text1}</p>
                <p>{props.text2}</p>
            </div>
        </div>
      </div>
    
  );
}

export default QuadProd;
